import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'

export function accountAddress(params) {
  return axios.request({
    url: `${urlObj.wss}wss-order/address`,
    method: 'get',
    params
  })
}

export function tableListPost(params, data) {
  return axios.request({
    url: `${urlObj.wss}wss-order/shopping/orderDetails`,
    method: 'post',
    params,
    data
  })
}

export function information(params) {
  return axios.request({
    url: `${urlObj.crm}crm/acceptInvoice/getTenantInvoice?shopId=${params}`,
    method: 'get'
  })
}

export function placeOrder(params, data) {
  return axios.request({
    url: `${urlObj.wss}wss-order/order/saveOrder`,
    method: 'post',
    params,
    data
  })
}

export function partsBuy(params) {
  return axios.request({
    url: `${urlObj.wss}wss-order/orders/parts/buy`,
    method: 'get',
    params
  })
}
